// stores/standard.ts
import { defineStore } from 'pinia';

export const useStandardStore = defineStore('standard', {
    state: () => ({
      expandedNodes: new Set<number>(),
      activeNodeId: null as number | null
    }),
    actions: {
      toggleNode(id: number) {
        this.expandedNodes.has(id) 
          ? this.expandedNodes.delete(id)
          : this.expandedNodes.add(id)
      },
      setActiveNode(id: number) {
        this.activeNodeId = id
      }
    }
  })
// stores/standard.ts
export const normalizeStandardData = (nodes: any[]): StandardNode[] => {
  return nodes.map(node => {
    // 动态检测子级字段 (支持任意levelX字段)
    const children: any[] = Object.keys(node)
      .filter(key => key.startsWith('level'))
      .reduce((acc: any[], key) => {
        if (Array.isArray(node[key])) {
          acc.push(...node[key])
        }
        return acc
      }, [])

    return {
      id: Number(node.id),
    numId: node.numId,
    name: node.name,
    content: node.content,
    image: node.image,
    level: Number(node.level),
    hasChildren: node[`level${Number(node.level)+1}`]?.length > 0,
    children: normalizeStandardData(node[`level${Number(node.level)+1}`] || [])    }
  })
}    